/*require("@babel/polyfill")*/;
import "core-js/stable";
import "regenerator-runtime/runtime";
window.React = require('react');
window.ReactDOM = require('react-dom');

/* All the components */
var base = require("./components/base.jsx")
var blocks = require("./components/blocks.jsx")
var filters = require("./components/filters.jsx")
filters.date = require("./components/dateFilter.jsx")
var forms = require("./components/forms.jsx")
var misc = require("./components/misc.jsx")
var buttons = require("./components/buttons.jsx")
var tables = require("./components/tables.jsx")
var insights = require("./components/insights.jsx")
var reports = require("./components/reports.jsx")
var popovers = require("./components/popovers.jsx")
var popups = require("./components/popups.jsx")
var files = require("./components/files.jsx")
var tabs = require("./components/tabs.jsx")
var utils = require("./utils.jsx")
var alerts = require("./components/alerts.jsx")

module.exports = {
  base: base,
  blocks: blocks,
  filters: filters,
  forms: forms,
  buttons: buttons,
  misc: misc,
  tables: tables,
  insights: insights,
  reports: reports,
  popovers: popovers,
  popups: popups,
  files: files,
  utils: utils,
  tabs: tabs,
  alerts: alerts
}
